<template>
  <div>
    <div class="local-currency-box d-flex align-center" v-if="currency.currency !== 'USD'">
      <div class="switch" @click="useLocalCurrency = !useLocalCurrency">
        <div :class="['slider', {'active':useLocalCurrency}]"></div>
      </div>
      <label>USE LOCAL CURRENCY</label>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.tripInfo}">
      <div class="heading" @click="contentShow.tripInfo = !contentShow.tripInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.tripInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.tripInfo"></i>
        <span>{{ $t('rsvpDetails.tripInformation.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.tripInformation.brand') }}:</div>
            <div class="value">
              <span class="brand" :style="{color: '#' + tripInfo.brandColor}">{{ tripInfo.brand }}</span>
            </div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.bookedThrough') }}:</div>
            <div class="value">
              <span v-bind:class="['booked-label', tripInfo.bookedThrough]">{{ tripInfo.bookedThrough }}</span>
            </div>
          </div>

          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.serviceType') }}:</div>
            <div class="value service-type">
              <span :class="['service-label', tripInfo.serviceType]" v-if="useOldQuatation">{{ tripInfo.serviceLabel }}</span>
              <span class="service-label" :style="{backgroundColor: tripInfo.serviceType.color}" v-else>{{ tripInfo.serviceType.label }}</span>
              <span class="service-label shared-optin" v-if="tripInfo.optinShared.isOptinShared && tripInfo.optinShared.current === 'shared'">Shared</span>
              <span class="service-label mtech-service" v-if="mtech.enabled">{{mtech.details.service.code}}</span>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.tripInformation.serviceArea') }}:</div>
            <div class="value">
              <span class="brand">{{ tripInfo.serviceArea }}</span>
            </div>
          </div>
          <div :class="['data-field col', tripInfo.isCharter || tripInfo.isRental ? 'col1' : 'col2']">
            <div class="label">{{ $t('rsvpDetails.tripInformation.fare') }}:</div>
            <div class="value">
              <span :class="{'cross grayed': tripInfo.optinShared.isOptinShared && tripInfo.optinShared.current === 'shared'}">
                <span v-if="!useLocalCurrency">${{ toFixed(totalFare) }}</span>
                <span v-else>{{ totalFareIntl }}</span>
              </span>
              <span v-if="tripInfo.optinShared.isOptinShared && tripInfo.optinShared.current === 'shared'" style="display: inline-block;margin: 0 5px;">/</span>
              <span v-if="tripInfo.optinShared.isOptinShared && tripInfo.optinShared.current === 'shared'" :class="['optin-fare', {'grayed': tripInfo.optinShared.current !== 'shared'}]">
                <span v-if="!useLocalCurrency">${{ toFixed(totalFareOptin) }}</span>
                <span v-else>{{ totalFareOptinIntl }}</span>
              </span>
            </div>
          </div>
          <div class="data-field col col1" v-if="tripInfo.isCharter || tripInfo.isRental">
            <div class="label all-caps">Duration:</div>
            <div class="value">{{ tripInfo.eta / 60 }} mins</div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.tripInformation.createdOn') }}:</div>
            <div class="value">{{ tripInfo.created }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">{{ $t('rsvpDetails.tripInformation.driverPayment') }}:</div>
            <div class="value">
              <span v-if="!useLocalCurrency">${{ totalDriverPayment }}</span>
              <span v-else>{{ totalDriverPaymentIntl }}</span>
              <a class="payment-trigger" @click="setShowPaymentBreakdown(true)">
                {{ $t('rsvpDetails.tripInformation.seePaymentBreakdown') }}
              </a>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label" v-if="tripInfo.isCharter || tripInfo.isRental">Start Date:</div>
            <div class="label" v-else>{{ $t('rsvpDetails.tripInformation.pickupDate') }}:</div>
            <div class="value">{{ tripInfo.pickupDate }}</div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.tip') }}:</div>
            <div class="value">
              <span v-if="!useLocalCurrency">${{ toFixed(tripInfo.tip) }}</span>
              <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.tipAmount}) }}</span> <!-- currency.currency = USD/INR -->
            </div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.airportFee') }}:</div>
            <div class="value">
              <span v-if="tripInfo.airportFee !== null && tripInfo.airportFee > 0">
                <span v-if="!useLocalCurrency">${{ toFixed(tripInfo.airportFee) }}</span>
                <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.airportFee}) }}</span>
              </span>
              <span v-else>N/A</span>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3" v-if="tripInfo.isCharter || tripInfo.isRental">
            <div class="label">End Date:</div>
            <div class="value">{{ computeEndDate(tripInfo) }}</div>
          </div>
          <div class="data-field col col3" v-else-if="mtech.enabled">
            <div class="label">LOCAL PICKUP DATE/TIME:</div>
            <div class="value">{{mtech.details.localPickupDate}}</div>
          </div>
          <div class="data-field col col3" v-else-if="isD2d || (tripInfo.localPickupTime && tripInfo.localPickupTime != tripInfo.pickupDate)">
            <div class="label">LOCAL PICKUP DATE/TIME:</div>
            <div class="value">{{tripInfo.localPickupTime}}</div>
          </div>
          <div class="data-field col col3" v-else>
            <div class="label">{{ $t('rsvpDetails.tripInformation.pickupType') }}:</div>
            <div class="value">
              <span v-if="tripInfo.pickup.geofenceType === 'airport'">
                <span v-if="isTncService && tripInfo.pickup.airportCode === 'LAX'">
                  LAXit 20A
                </span>
                <span v-else-if="!tripInfo.meetAndGreet">Curbside</span>
                <span v-else>
                  Meet & Greet
                  (
                    <span v-if="tripInfo.pickupFee && !useLocalCurrency">{{ '$' + toFixed(tripInfo.pickupFee) }}</span>
                    <span v-else-if="tripInfo.pickupFee && useLocalCurrency">{{ xcurrency.format({code: currency.currency, val: currency.pickupFee}) }}</span>
                    <span v-else>Complimentary</span>
                  )
                </span>
              </span>
              <span v-else>N/A</span>
            </div>
          </div>
          <div class="data-field col col1" v-if="!tripInfo.isCharter || tripInfo.isRental">
            <div class="label all-caps">{{ travelInsuranceLabel }}:</div>
            <div class="value">
              <span v-if="!useLocalCurrency">${{ toFixed(tripInfo.travelInsurance) }}</span>
              <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.travelInsurance}) }}</span>
            </div>
          </div>
          <div class="data-field col col1" v-if="tripInfo.gasFee !== null && tripInfo.gasFee > 0">
            <div class="label">Fuel Surcharge:</div>
            <div class="value">
              <span v-if="!useLocalCurrency">${{ toFixed(tripInfo.gasFee) }}</span>
              <span v-else>{{ xcurrency.format({code: currency.currency, val: currency.gasFee}) }}</span>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col5">
            <div class="label">{{ $t('rsvpDetails.tripInformation.pickup') }}:</div>
            <div class="value">{{ tripInfo.pickup.title }}</div>
          </div>
        </div>

        <div class="field-row" v-if="extraStops.length">
          <div class="data-field col col5">
            <div class="label">Extra Stop:</div>
            <div class="value" v-for="(stop,index) in extraStops" :key="index">{{ extraStopAddress(stop) }}</div>
          </div>
        </div>

        <div class="field-row" v-if="!tripInfo.isCharter && !tripInfo.isRental">
          <div class="data-field col col5">
            <div class="label">{{ $t('rsvpDetails.tripInformation.dropoff') }}:</div>
            <div class="value">{{ tripInfo.dropoff.title }}</div>
          </div>
        </div>

        <div class="field-row" v-if="!tripInfo.isCharter && !tripInfo.isRental">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.tripInformation.beThereTime') }}:</div>
            <div class="value">{{ tripInfo.beThereTime }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">{{ $t('rsvpDetails.tripInformation.distance') }}:</div>
            <div class="value">{{ tripInfo.distance }}mi</div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.tripInformation.flightInfo') }}:</div>
            <div class="value">
              {{ flightInfo }}
              <span class="flightLabel" v-show="flightInfo !== 'N/A' && !isD2d">
                <i class="fa fa-circle-notch fa-spin" v-show="flightLoading"></i>
                <label v-if="!flightLoading && !statusDone" @click="showFlightStatus"
                  :class="[flightStatus.class]">{{ flightStatus.label }}</label>
              </span>
            </div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.passenger') }}:</div>
            <div class="value">{{ tripInfo.passenger }}</div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.luggage') }}:</div>
            <div class="value">{{ tripInfo.luggage }}</div>
          </div>
        </div>

        <div class="field-row" v-if="!!tripInfo.terminal">
          <div class="data-field col col5">
            <div class="label">{{ $t('rsvpDetails.tripInformation.terminal') }}:</div>
            <div class="value">{{ tripInfo.terminal }}</div>
          </div>
        </div>

        <div class="field-row" v-if="tripInfo.portalFee">
          <div class="data-field col col5">
            <div class="label">Convenience Fee:</div>
            <div class="value">
              <span v-if="!useLocalCurrency">${{ toFixed(tripInfo.portalFee) }}</span>
              <span v-else>{{ convenienceFeeIntl }}</span>
            </div>
          </div>
        </div>

        <div class="field-row" v-if="tripInfo.rating > 0">
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.tripInformation.rating') }}:</div>
            <div class="value"><i class="fa fa-star"></i> {{ tripInfo.rating }}</div>
          </div>
          <div class="data-field col col4" v-show="!!tripInfo.userReview">
            <div class="label">{{ $t('rsvpDetails.tripInformation.userReview') }}:</div>
            <div class="value">{{ tripInfo.userReview }}</div>
          </div>
        </div>

        <div class="field-row" v-if="customerInfo.externalId || customerInfo.alternatePhone">
          <div class="data-field col col3" v-if="customerInfo.externalId">
            <div class="label">External ID:</div>
            <div class="value">{{ customerInfo.externalId }}</div>
          </div>
          <div class="data-field col col2" v-if="customerInfo.alternatePhone">
            <div class="label">Alternate Phone:</div>
            <div class="value">
              <a @click="call({mobile: customerInfo.alternatePhone, firstName: customerInfo.firstName, lastName: customerInfo.lastName})">{{ customerInfo.alternatePhone }}</a>
            </div>
          </div>
        </div>

        <div class="field-row" v-show="tripInfo.notes !== '' && tripInfo.notes !== null">
          <div class="data-field col col5">
            <div class="label">{{ $t('rsvpDetails.tripInformation.notes') }}:</div>
            <div class="value">{{ tripInfo.notes }}</div>
          </div>
        </div>

        <div class="field-row">
          <a class="button cta small right"
            @click="optinModal = true" v-if="tripInfo.optinShared.isOptinShared && tripInfo.status === 'upcoming' && !tripInfo.packageId">
            <span v-if="tripInfo.optinShared.current === 'exclusive'">Convert to Shared</span>
            <span v-else>Convert back to Exclusive</span>
          </a>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.otherInfo}">
      <div class="heading" @click="contentShow.otherInfo = !contentShow.otherInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.otherInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.otherInfo"></i>
        <span>Other Information</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">Hudson ID:</div>
            <div class="value">{{ otherInfo.externalId }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">Alternate Phone:</div>
            <div class="value">
              <span v-if="otherInfo.alternatePhone === 'N/A'">N/A</span>
              <a @click="call({mobile: otherInfo.alternatePhone, firstName: otherInfo.firstName, lastName: otherInfo.lastName})" v-else>{{ otherInfo.alternatePhone }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.businessInfo}" v-if="isCorporate">
      <div class="heading" @click="contentShow.businessInfo = !contentShow.businessInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.businessInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.businessInfo"></i>
        <span>Business Information</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">Corporate Name:</div>
            <div class="value">{{ businessInfo.corporateName }}</div>
          </div>
          <div class="data-field col col1">
            <div class="label">ID:</div>
            <div class="value">
              <a v-bind:href="'/#/corporate/' + businessInfo.id"
                target="_blank">{{ businessInfo.id }}</a>
            </div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.customerInformation.paidWith') }}:</div>
            <div class="value credit-card">{{ creditCard }}</div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">Passenger Name:</div>
            <div class="value">{{ businessInfo.firstName + ' ' + businessInfo.lastName }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">Passenger Mobile:</div>
            <div class="value">
              <a @click="call(businessInfo)">{{ businessInfo.mobile }}</a>
            </div>
          </div>
        </div>

        <div class="field-row">
          <a :class="{'button cta success small right':true, 'disabled':emailLoading}"
            @click="sendEmail" v-if="tripInfo.reservationState !== 'NOSHOW'">
            <span v-show="showConfirmEmail && !emailLoading">
              {{ $t('rsvpDetails.sendConfirmationEmail') }}
            </span>
            <span v-show="rsvpStatus === 'complete' && !emailLoading">
              {{ $t('rsvpDetails.sendReceiptEmail') }}
            </span>
            <span v-show="rsvpStatus === 'canceled' && !emailLoading">
              {{ $t('rsvpDetails.sendCancellationEmail') }}
            </span>
            <span v-show="emailLoading">
              <i class="fa fa-spinner fa-spin"></i>
              {{ $t('rsvpDetails.sending') }}
            </span>
          </a>
          <div>
            <a :class="{'button cta small right trip-reminder-btn':true, 'disabled':tripRemindLoading}"
              @click="sendTripReminder" v-if="!hideReminderButton">
              <span v-if="!tripRemindLoading">Send Trip Reminder</span>
              <span v-else>{{ $t('rsvpDetails.sending') }}</span>
            </a>
          </div>
          <div v-if="showConfirmEmail && driverInfo.id">
            <a :class="['button cta small right no-show-btn', hasRSVPControl ? 'warning' : 'secondary disabled', {'disabled':noShow.loading}]"
              @click="sendNoShow" v-if="!noShow.forceHide">{{ $t('rsvpDetails.noShow.label') }}</a>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.customerInfo}" v-show="!isCorporate">
      <div class="heading" @click="contentShow.customerInfo = !contentShow.customerInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.customerInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.customerInfo"></i>
        <span>{{ $t('rsvpDetails.customerInformation.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.customerInformation.name') }}:</div>
            <div class="value">{{ customerName }}</div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.customerInformation.id') }}:</div>
            <div class="value">
              <a v-bind:href="'/#/consumer/' + customerInfo.id"
                target="_blank">{{ customerInfo.id }}</a>
            </div>
          </div>
          <div class="data-field col col1">
            <div class="label">{{ $t('rsvpDetails.customerInformation.paidWith') }}:</div>
            <div class="value credit-card">{{ creditCard }}</div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.customerInformation.email') }}:</div>
            <div class="value">
              <p class="truncate">
                <a v-bind:href="'mailto:' + customerInfo.email">{{ customerInfo.email }}</a>
              </p>
            </div>
          </div>
          <div class="data-field col col2">
            <div class="label">{{ $t('rsvpDetails.customerInformation.mobile') }}:</div>
            <div class="value">
              <span v-if="customerInfo.mobile === 'N/A'">{{ customerInfo.mobile }}</span>
              <a @click="call(customerInfo)" v-else>{{ displayPhone(customerInfo.phone) }}</a>
            </div>
          </div>
        </div>

        <div class="field-row">
          <a :class="{'button cta success small right':true, 'disabled':emailLoading}"
            @click="sendEmail" v-if="(showConfirmEmail && !isD2d) || !showConfirmEmail"> <!-- v-if="tripInfo.reservationState !== 'NOSHOW'" -->
            <span v-show="showConfirmEmail && !emailLoading">
              {{ $t('rsvpDetails.sendConfirmationEmail') }}
            </span>
            <span v-show="rsvpStatus === 'complete' && !emailLoading">
              {{ $t('rsvpDetails.sendReceiptEmail') }}
            </span>
            <span v-if="tripInfo.reservationState === 'NOSHOW' && !emailLoading">
              SEND NO SHOW EMAIL
            </span>
            <span v-else-if="rsvpStatus === 'canceled' && !emailLoading">
              {{ $t('rsvpDetails.sendCancellationEmail') }}
            </span>
            <span v-show="emailLoading">
              <i class="fa fa-spinner fa-spin"></i>
              {{ $t('rsvpDetails.sending') }}
            </span>
          </a>
          <div>
            <a :class="{'button cta small right trip-reminder-btn':true, 'disabled':tripRemindLoading}"
              @click="sendTripReminder" v-if="!hideReminderButton">
              <span v-if="!tripRemindLoading">Send Trip Reminder</span>
              <span v-else>{{ $t('rsvpDetails.sending') }}</span>
            </a>
          </div>
          <div v-if="showConfirmEmail && driverInfo.id && ((lyft.show && ['dispatched', 'ontheway', 'onboard', 'pickup'].indexOf(tripInfo.bidStatus) == -1 ) || !lyft.show)">
            <a :class="['button cta small right no-show-btn', hasRSVPControl ? 'warning' : 'secondary disabled', {'disabled':noShow.loading}]"
              @click="sendNoShow" v-if="!noShow.forceHide">{{ $t('rsvpDetails.noShow.label') }}</a>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.guestInfo}" v-show="!isCorporate">
      <div class="heading" @click="contentShow.guestInfo = !contentShow.guestInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.guestInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.guestInfo"></i>
        <span>{{ $t('rsvpDetails.guestInformation.label') }}</span>
      </div>

      <div class="content">
        <div class="field-row" v-show="!noGuest">
          <div class="data-field col col3">
            <div class="label">{{ $t('rsvpDetails.guestInformation.name') }}:</div>
            <div class="value">{{ guestName }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">{{ $t('rsvpDetails.guestInformation.mobile') }}:</div>
            <div class="value">
              <a @click="call(guestInfo)" v-if="guestInfo.mobile !== '' && guestInfo.mobile !== '+1'">{{ guestInfo.mobile }}</a>
              <span v-else>N/A</span>
            </div>
          </div>
        </div>

        <div class="empty-state" v-show="noGuest">
          <p>{{ $t('rsvpDetails.guestInformation.emptyState') }}</p>
          <!-- <button class="button small cta warning" v-if="!removeAddGuest">
            {{ $t('rsvpDetails.guestInformation.addBtn') }}
          </button> -->
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.driverInfo}" v-if="!lyft.show">
      <div class="heading" @click="contentShow.driverInfo = !contentShow.driverInfo">
        <i class="fa fa-minus-circle" v-show="contentShow.driverInfo"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.driverInfo"></i>
        <span>{{ $t('rsvpDetails.driverInformation.label') }}</span>
      </div>

      <div class="content">
        <div v-show="!noDriver">
          <div class="field-row">
            <div class="data-field col col3">
              <div class="label">{{ $t('rsvpDetails.driverInformation.name') }}:</div>
              <div class="value driver-name">
                <div class="name">
                {{ driverName }}
                </div>
                <div class="prov-options"
                  @mouseover="clearOptionDelay" @mouseout="hideOptions">
                  <i class="fas fa-ellipsis-v fa-lg" @click="showOptions = !showOptions"></i>

                  <transition name="slide-down">
                    <div class="options" v-show="showOptions">
                      <div class="button cta success block call" @click="call(driverInfo)">
                        <i class="fa fa-phone"></i>{{ $t('provider.call') }}
                      </div>
                      <div class="button cta block send-sms" @click="sendSMS(driverInfo)">
                        <i class="fas fa-comment-dots"></i>{{ $t('provider.sms') }}
                      </div>
                      <div class="button cta warning block send-notif" @click="showNotif">
                        <i class="fas fa-bell"></i>{{ $t('provider.notify') }}
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="data-field col col1">
              <div class="label">{{ $t('rsvpDetails.driverInformation.id') }}:</div>
              <div class="value">
                <a v-bind:href="'/#/provider/' + driverInfo.id"
                  target="_blank">{{ driverInfo.driverNum }}</a>
              </div>
            </div>
            <div class="data-field col col1">
              <div class="label">{{ $t('rsvpDetails.driverInformation.avgRating') }}:</div>
              <div class="value"><i class="fa fa-star"></i>{{ driverInfo.rating }}</div>
            </div>
          </div>

          <div class="field-row">
            <div class="data-field col col1">
              <div class="label">{{ $t('rsvpDetails.driverInformation.make') }}:</div>
              <div class="value">{{ driverInfo.make }}</div>
            </div>
            <div class="data-field col col2">
              <div class="label">{{ $t('rsvpDetails.driverInformation.model') }}:</div>
              <div class="value">{{ driverInfo.model }}</div>
            </div>
            <div class="data-field col col2">
              <div class="label">{{ $t('rsvpDetails.driverInformation.licensePlate') }}:</div>
              <div class="value">{{ driverInfo.licensePlate }}</div>
            </div>
          </div>

          <div class="field-row">
            <div class="data-field col col3">
              <div class="label">{{ $t('rsvpDetails.driverInformation.email') }}:</div>
              <div class="value">
                <p class="truncate">
                  <a v-bind:href="'mailto:' + driverInfo.email">{{ driverInfo.email }}</a>
                </p>
              </div>
            </div>
            <div class="data-field col col2">
              <div class="label">{{ $t('rsvpDetails.driverInformation.mobile') }}:</div>
              <div class="value">
                <a @click="call(driverInfo)">+{{ driverInfo.countryCode }} {{ driverInfo.nationalNumber }}</a>
              </div>
            </div>
          </div>
          <a class="button small cta error" v-show="showReleaseButton" href="javascript:;"
            @click="$store.commit('rsvpDetails/showReleaseConfirmation')">
            {{ $t('rsvpDetails.driverInformation.releaseBtn') }}
          </a>
        </div>

        <div class="empty-state" v-show="noDriver">
          <p>{{ $t('rsvpDetails.driverInformation.emptyState') }}</p>
          <!-- <button class="button small cta warning">{{ $t('rsvpDetails.driverInformation.findBtn') }}</button> -->
        </div>
      </div>
    </div>

    <div :class="{'collapsible':true, 'collapse':!contentShow.lyft}" v-if="lyft.show">
      <div class="heading" @click="contentShow.lyft = !contentShow.lyft">
        <i class="fa fa-minus-circle" v-show="contentShow.lyft"></i>
        <i class="fa fa-plus-circle" v-show="!contentShow.lyft"></i>
        <span>Lyft Information</span>
      </div>

      <div class="content">
        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">Lyft Ride ID:</div>
            <div class="value">{{ lyft.rideId }}</div>
          </div>
          <div class="data-field col col2" v-if="lyft.date">
            <div class="label">Send Date:</div>
            <div class="value">{{ lyft.date }}</div>
          </div>
        </div>

        <div class="field-row">
          <div class="data-field col col3">
            <div class="label">Lyft Ride Type:</div>
            <div class="value">{{ lyftServiceLabel(lyft.rideType) }}</div>
          </div>
          <!-- <div class="data-field col col2">
            <div class="label">Lyft ID:</div>
            <div class="value">{{ lyft.id }}</div>
          </div> -->
        </div>

        <div class="field-row" v-if="lyft.driver.id">
          <div class="data-field col col5">
            <div class="label">Driver:</div>
            <div class="value">{{ lyft.driver.first_name }}</div>
          </div>
        </div>

        <div class="field-row" v-if="lyft.driver.id">
          <div class="data-field col col3">
            <div class="label">Mobile:</div>
            <div class="value">{{ lyft.driver.phone_number }}</div>
          </div>
          <div class="data-field col col2">
            <div class="label">Rating:</div>
            <div class="value">{{ lyft.driver.rating }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import request from 'browser-request'
import moment from 'moment'
import ApiRsvp from '../../modules/api/reservations'
import featureToggle from '../../modules/api/featureToggle'
import common from '@/modules/plugins/common'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'basic-information',
  data () {
    return {
      contentShow: {
        tripInfo: false,
        otherInfo: false,
        customerInfo: false,
        guestInfo: false,
        businessInfo: false,
        driverInfo: false,
        lyft: true
      },
      flightLoading: false,
      emailLoading: false,
      tripRemindLoading: false,
      showOptions: false,
      showOptionsDelay: '',
      isTncService: false,
      xcurrency: xcurrency
    }
  },
  computed: {
    rsvpId () { return this.$route.params.id },
    isCorporate () { return this.$store.state.rsvpDetails.basicInfo.businessInfo.id },
    travelInsuranceLabel () { return this.$settings.get('TravelInsuranceLabel') },
    tripInfo () { return this.$store.state.rsvpDetails.basicInfo.tripInfo },
    customerInfo () { return this.$store.state.rsvpDetails.basicInfo.customerInfo },
    guestInfo () { return this.$store.state.rsvpDetails.basicInfo.guestInfo },
    driverInfo () { return this.$store.state.rsvpDetails.basicInfo.driverInfo },
    businessInfo () { return this.$store.state.rsvpDetails.basicInfo.businessInfo },
    otherInfo () { return this.$store.state.rsvpDetails.basicInfo.otherInfo },
    flightInfo () {
      if (!this.tripInfo.airline || this.tripInfo.airline === null) {
        return 'N/A'
      }
      return this.tripInfo.airline + ' ' + (this.tripInfo.flightNo || '')
    },
    customerName () { return this.customerInfo.firstName + ' ' + this.customerInfo.lastName },
    guestName () {
      let firstName = this.guestInfo.firstName || ''
      let lastName = this.guestInfo.lastName || ''
      if (!firstName && !lastName) return '--'
      return firstName + ' ' + lastName
    },
    driverName () { return this.driverInfo.firstName + ' ' + this.driverInfo.lastName },
    noGuest () {
      return (this.guestInfo.firstName === '' || this.guestInfo.firstName === null) &&
        (this.guestInfo.lastName === '' || this.guestInfo.lastName === null) &&
        (this.guestInfo.mobile === '' || this.guestInfo.mobile === null)
    },
    noDriver () { return this.driverInfo.id === '' || this.driverInfo.id === null },
    totalDriverPayment () {
      let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
      let driverPayment = tripInfo.driverPayment
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment
      }
      return this.toFixed(driverPayment + tripInfo.driverBonus +
        tripInfo.tip + tripInfo.pickupFee + tripInfo.gasFee)
    },
    isDispatch () { return this.$store.state.rsvpDetails.basicInfo.tripInfo.bidStatus === 'dispatched' },
    rsvpStatus () { return this.$store.state.rsvpDetails.basicInfo.tripInfo.status },
    showReleaseButton () { return this.rsvpStatus !== 'canceled' && this.rsvpStatus !== 'complete' },
    showConfirmEmail () { return this.rsvpStatus !== 'canceled' && this.rsvpStatus !== 'complete' },
    flightStatus () {
      let flight = Object.assign({}, this.$store.state.rsvpDetails.flightStatus)
      if (flight.status === '' || flight.status === null) {
        flight.status = 'Scheduled'
      }
      return this.translateFlightStatus(flight.status)
    },
    removeAddGuest () {
      let rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo
      return rsvpDetails.status === 'canceled' ||
        rsvpDetails.status === 'complete' ||
        rsvpDetails.bidStatus === 'dispatched'
    },
    statusDone () {
      let rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo
      return rsvpDetails.status === 'canceled' || rsvpDetails.status === 'complete'
    },
    isTerminal () { return this.$store.state.rsvpDetails.isTerminal },
    creditCard () {
      if (this.isCorporate) {
        if (common.isFDBrand(this.tripInfo.brandId)) return 'Direct Bill'
        if (this.isTerminal) return 'Terminal'
        return this.customerInfo.creditCard === '' || this.customerInfo.creditCard === null ?
        'Direct Bill' : '**** ' + this.customerInfo.creditCard
      }
      if (this.isTerminal) {
        return 'Terminal'
      }
      if (this.customerInfo.id === CONFIG.goResUserId) {
        return 'Direct Bill'
      }
      return this.customerInfo.creditCard === '' || this.customerInfo.creditCard === null ?
        'N/A' : '**** ' + this.customerInfo.creditCard
    },
    totalFare () {
      let total = this.tripInfo.tip + this.tripInfo.fare + this.tripInfo.pickupFee + this.tripInfo.gasFee + this.tripInfo.travelInsurance + this.tripInfo.portalFee - this.tripInfo.credits
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total = total + this.tripInfo.airportFee
      }
      return total < 0 ? 0 : total
    },
    noShow () { return this.$store.state.rsvpDetails.sendNoShow },
    useOldQuatation () { return CONFIG.useOldQuatation },
    hideReminderButton () {
      let rsvpDetails = this.$store.state.rsvpDetails.basicInfo.tripInfo
      return rsvpDetails.status === 'canceled' ||
        rsvpDetails.status === 'complete' ||
        rsvpDetails.reservationState === 'NOSHOW'
    },
    extraStops () { return this.$store.state.rsvpDetails.extraStops },
    services () { return this.$store.state.services },
    optin () { return this.$store.state.rsvpDetails.optin },
    optinModal: {
      get () { return this.optin.showModal },
      set (x) { this.$store.commit('rsvpDetails/setOptinData', {showModal: x}) }
    },
    totalFareOptin () {
      let total = this.tripInfo.tip + this.tripInfo.optinShared.shared.amount + this.tripInfo.pickupFee + this.tripInfo.gasFee + this.tripInfo.travelInsurance - this.tripInfo.credits
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total = total + this.tripInfo.airportFee
      }
      return total < 0 ? 0 : total
    },
    hasRSVPControl () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminRsvpControl') },
    mtech () { return this.$store.state.rsvpDetails.mtech },
    isD2d () { return this.d2dId },
    currency () { return this.$store.state.rsvpDetails.currency },
    useLocalCurrency: {
      get () { return this.$store.state.rsvpDetails.useLocalCurrency },
      set (x) { this.$store.commit('rsvpDetails/setLocalCurrency', x) }
    },
    totalFareIntl () {
      let total = parseFloat(this.currency.amount) + parseFloat(this.currency.pickupFee) +
        parseFloat(this.currency.tipAmount) + parseFloat(this.currency.gasFee) +
        parseFloat(this.currency.travelInsurance) - parseFloat(this.currency.credit)
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total += parseFloat(this.currency.airportFee)
      }
      return xcurrency.format({
        code: this.currency.currency,
        val: total.toFixed(2)
      })
    },
    totalFareOptinIntl () {
      let total = this.applyCurrency(this.tripInfo.optinShared.shared.amount, false) + 
        parseFloat(this.currency.pickupFee) + parseFloat(this.currency.tipAmount) +
        parseFloat(this.currency.gasFee) + parseFloat(this.currency.travelInsurance) -
        parseFloat(this.currency.credit)
      if (this.tripInfo.airportFee !== null && this.tripInfo.airportFee > 0) {
        total += parseFloat(this.currency.airportFee)
      }
      return xcurrency.format({
        code: this.currency.currency,
        val: total.toFixed(2)
      })
    },
    totalDriverPaymentIntl () {
      let tripInfo = this.$store.state.rsvpDetails.basicInfo.tripInfo
      let driverPayment = tripInfo.driverPayment
      if (parseFloat(tripInfo.overridePayment) > 0) {
        driverPayment = tripInfo.overridePayment
      }
      driverPayment = this.applyCurrency(driverPayment, false)
      let total = driverPayment + this.applyCurrency(tripInfo.driverBonus, false) +
        this.currency.tipAmount + this.currency.pickupFee + this.currency.gasFee
      return xcurrency.format({
        code: this.currency.currency,
        val: total.toFixed(2)
      })
    },
    lyft () { return this.$store.state.rsvpDetails.lyft },
    lyftStore () { return this.$store.state.lyft },
    convenienceFeeIntl () {
      return xcurrency.format({
        code: this.currency.currency,
        val: this.tripInfo.portalFee.toFixed(2)
      })
    }
  },
  methods: {
    setShowPaymentBreakdown (value) {
      this.$store.commit('rsvpDetails/setShowPaymentBreakdown', value)
    },
    call (user) {
      let self = this
      self.showOptions = false
      let phone = `${user.phone.countryCode}${user.phone.number}`
      self.$plugins.phone.startCall(self, {
        phone: parseInt(phone),
        name: user.firstName + ' ' + user.lastName
      })
    },
    getFlightStatus (labelOnly) {
      let self = this
      if (self.flightLoading) { return }
      self.flightLoading = true
      let pickupDate = moment(self.tripInfo.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      let isDeparture = this.tripInfo.isAirportPickup ? '0' : '1'
      ApiRsvp.getFlightStatus(self, {
        flightCode: self.tripInfo.airlineCode + self.tripInfo.flightNo,
        date: pickupDate.format('YYYY-MM-DD'),
        time: pickupDate.format('HH:mm:ss'),
        isDeparture: isDeparture,
        airportCode: self.tripInfo.airportCode
      }, function (res) {
        self.flightLoading = false
      })
    },
    showFlightStatus () {
      this.$store.commit('rsvpDetails/setShowFlightStatus', true)
    },
    toFixed (value) {
      return parseFloat(value).toFixed(2)
    },
    translateFlightStatus (status) {
      switch (status) {
        case 'Scheduled': return { label: 'On Time', class: 'ontime' }
        case 'Proposed': return { label: 'On Time', class: 'ontime' }
        case 'OutGate': return { label: 'On Time', class: 'ontime' }
        case 'InAir': return { label: 'On Air', class: 'onair' }
        case 'Landed': return { label: 'Arrived', class: 'arrived' }
        case 'InGate': return { label: 'Arrived', class: 'arrived' }
        case 'Arrived': return { label: 'Arrived', class: 'arrived' }
        case 'Expected': return { label: 'On Time', class: 'ontime' }
        case 'NoTakeOffInfo': return { label: 'On Time', class: 'ontime' }
        case 'Delayed': return { label: 'Delayed', class: 'delayed' }
        case 'Cancelled': return { label: 'Cancelled', class: 'cancelled' }
        case 'Unknown': return { label: 'On Time', class: 'ontime' }
        case 'PastFlight': return { label: 'Arrived', class: 'arrived' }
        case 'Original' : return { label: 'On Time', class: 'ontime' }
      }
      return { label: 'On Time', class: 'ontime' }
    },
    sendEmail () {
      let title = 'Send Confirmation Email'
      if (this.rsvpStatus === 'complete') {
        title = 'Send Receipt Email'
      }
      if (this.rsvpStatus === 'canceled') {
        title = 'Send Cancellation Email'
      }
      if (this.tripInfo.reservationState === 'NOSHOW') {
        title = 'Send No Show Email'
      }
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'title',
        value: title
      })
      this.$store.commit('rsvpDetails/setEmailRecipientField', {
        field: 'show',
        value: true
      })
      // let self = this
      // self.emailLoading = true
      // ApiRsvp.sendEmail(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
      //   self.emailLoading = false
      //   self.$store.commit('rsvpDetails/setSendEmail', {
      //     show: true,
      //     message: self.$t('rsvpDetails.emailSent')
      //   })

      //   if (res.error) {
      //     self.$store.commit('rsvpDetails/setSendEmail', {
      //       show: true,
      //       message: res.error.message
      //     })
      //   }
      // })
    },
    sendNoShow () {
      if (!this.hasRSVPControl) return

      this.$store.commit('rsvpDetails/setSendNoShow', {
        showModal: true,
        loading: false,
        showMsg: false,
        message: '',
        forceHide: this.$store.state.rsvpDetails.sendNoShow.forceHide
      })
    },
    sendTripReminder () {
      let self = this
      self.tripRemindLoading = true
      ApiRsvp.sendTripReminder(self, self.$store.state.rsvpDetails.rsvpId, function (res) {
        self.tripRemindLoading = false
        self.$store.commit('rsvpDetails/setSendEmail', {
          show: true,
          message: self.$t('rsvpDetails.emailSent')
        })

        if (res.error) {
          self.$store.commit('rsvpDetails/setSendEmail', {
            show: true,
            message: res.error.message
          })
        }
      })
    },
    hideOptions () {
      let self = this
      self.showOptionsDelay = setTimeout(function () {
        self.showOptions = false
      }, 1500)
    },
    clearOptionDelay () {
      if (this.showOptionsDelay) { clearTimeout(this.showOptionsDelay) }
    },
    sendSMS () {
      this.showOptions = false
      this.$parent.sendSMS()
    },
    showNotif () {
      this.showOptions = false
      this.$parent.showNotif()
    },
    extraStopAddress (x) {
      return `${x.address2} ${x.address1}, ${x.city}, ${x.state} ${x.zipCode}`
    },
    computeEndDate (x) {
      let endDate = moment(x.pickupDate, 'MM/DD/YYYY hh:mmA').add(x.eta, 'seconds')
      return endDate.format('MM/DD/YYYY hh:mmA')
    },
    checkTncService () {
      this.isTncService = false
      if (!this.services.list.length || !this.tripInfo.serviceTypeId) return
      let service = this.services.list.find(x => x.id === this.tripInfo.serviceTypeId)
      if (service && service.allowTNC) {
        this.isTncService = true
      }
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.currencyRate
      return useSymbol ? `${this.currency.symbol}${x.toFixed(2)}` : parseFloat(x.toFixed(2))
    },
    displayPhone (data) {
      let phone = ''
      if (data) phone = `${data.countryCode} ${data.number}`
      if (data && !phone.includes('+')) phone = `+${phone}`
      return phone
    },
    lyftServiceLabel (x) {
      return this.lyftStore.services[x] ? this.lyftStore.services[x].name : x
    }
  },
  watch: {
    tripInfo: function (value) {
      this.contentShow.tripInfo = true
      if (value.airlineCode !== '' && value.airlineCode !== null &&
        this.rsvpStatus !== 'complete' && this.rsvpStatus !== 'canceled'
      ) {
        this.getFlightStatus(true)
      }
    },
    businessInfo: function () { this.contentShow.businessInfo = true },
    customerInfo: function () { this.contentShow.customerInfo = true },
    guestInfo: function () { this.contentShow.guestInfo = true },
    driverInfo: function () { this.contentShow.driverInfo = true },
    otherInfo: function () { this.contentShow.otherInfo = true },
    'services.serviceLoading': function (val) {
      if (val) {
        this.checkTncService()
      }
    },
    'tripInfo.serviceTypeId': function (val) {
      if (val) {
        this.checkTncService()
      }
    },
    'lyft.show': function (val) {
      this.contentShow.lyft = val
    }
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;

.collapsible{
  margin-bottom: 5px;

  .heading{
    color: $cta-link;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 700px; /* define precise max-height for more smoother transition */
    height: auto;
    overflow: visible;
    transition:all 0.35s ease-out;

    .field-row{ margin-bottom: 15px; }
    .field-row:last-child{ margin-bottom: 0; }
  }
  &.collapse .content{
    max-height: 0;
    padding: 0 15px;
    overflow: hidden;
  }
}

.field-row{
  box-sizing: border-box;
  display: flex;

  .col{ display: inline-block; }
  .col1{ width: 20%; }
  .col2{ width: 40%; }
  .col3{ width: 60%; }
  .col4{ width: 80%; }
  .col5{ width: 100%; }
}

.booked-label{
  color: #fff;
  background: #ccc;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  line-height: 1;
  display: inline-block;
  margin-top: 2px;

  &.Web{ background: #a26d5d; }
  &.Android{ background: #78c259; }
  &.iOS{ background: #7fc8de; }
  &.Admin{ background: #2b83f1; }
  &.CSR{ background: #bb4a91; }
  &.Provider{ background: #3f3f3f; }
}

.service-label{
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
  margin-top: 2px;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
  &.shared-optin {
    background: #dd9a54;
    border: 2px solid #a55b2e;
  }
  &.mtech-service{
    background: #18ab4c;
    border: 1px solid #398316;
  }
}

.data-field{
  font-weight: 600;
  .label{
    color: #888;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 120%;
  }
  .value{
    font-size: 17px;
    color: #555;

    &.driver-name{ display: flex; }
    &.service-type{ text-transform: capitalize; }
    &.credit-card{ font-size: 16px; }
    .fa-star{
      color: #f1d724;
      margin-right: 5px;
    }
    .payment-trigger{
      font-size:11px;
      vertical-align: 3px;
      text-decoration: underline;
      margin-left: 2px;
      cursor: pointer;
    }
    a{
      text-decoration: underline;
      cursor: pointer;
    }
    .cross{
      text-decoration: line-through;
    }
    .grayed{
      color: #888;
    }
  }
}

.trip-reminder-btn, .no-show-btn{ margin-left: 10px; }

.empty-state{
  font-weight: 600;
  color: #555;
  font-size: 18px;

  p{ margin: 0 0 5px; }
  button{ cursor: pointer; }
}

.breakdown-modal{
  position: fixed;
  z-index: 12;
  background: #f00;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.flightLabel{
  .fa-circle-notch{
    color: #0D79F2;
  }
  label{
    cursor: pointer;
    font-size: 11px;
    vertical-align: middle;
    color: #fff;
    background: #ccc;
    padding: 2px 6px;
    margin-left: 4px;
    border-radius: 3px;
    text-transform: uppercase;
    font-weight: 100;

    &.Scheduled { background: #b97a2b; }
    &.Active { background: #43b3e8; }
    &.Unknown { background: #333; }
    &.Redirected { background: #dc4c4c; }
    &.Landed { background: #2bb971; }
    &.Diverted { background: #b92b87; }
    &.Cancelled { background: #8a8a8a; }
    &.arrived { background: #26D97A; }
    &.Not.Operational { background: #ef4958; }
  }
}
.truncate {
  margin: 0;
}
@media only screen and (max-width: 430px) {
  .data-field {
    .label {
      font-size: 10px;
      white-space: nowrap;
    }
    .value {
      font-size: 15px;
      .payment-trigger {
        display: block;
      }
    }
  }

  .empty-state {
    color: #999;
    font-size: 15px;
  }

  .field-row {
    .col1 {
      width: 23%;
    }
    .col3 {
      width: 50%;
    }
  }

  .flightLabel {
    label {
      display: inline-block;
      margin-left: 0;
    }
  }
  .truncate {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .button.small {
    font-size: 11px;
    padding: 7px;
  }
}

.prov-options{
  display: flex;
  align-items: center;
  margin-left: 5px;
  cursor: pointer;
  color: #0D79F2;
  transition: all .4s ease;
  position: relative;
  z-index: 5;

  .fa-ellipsis-v{ font-size: 18px; }
  &:hover{ color: #333; }
  .options{
    transform-origin: top center;
    position: absolute;
    top: 120%;
    width: 200px;
    background: #fff;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 1px 1px 4px rgba(0,0,0, .2);

    .button {
      margin-bottom: 3px;

      i {
        margin-right: 5px;
      }
    }
  }
}

.optin-icon{
  font-size: 14px;
  margin-bottom: 10px;
  img {
    width: 18px;
    vertical-align: -3px;
    margin-right: 5px;
  }
}
.optin-fare{
  display: inline-block;
}

.switch{
  position: relative;
  display: inline-block;
  height: 23px;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 23px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 30px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 10px;
    margin-left: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}
.local-currency-box{
  margin-bottom: 10px;
  background: #fff792;
  border: 1px solid #cdc23d;
  padding: 5px;
  border-radius: 5px;

  label{
    font-size: 13px;
    color: #565656;
    margin-left: 5px;
    font-family: 'Space Grotesk';
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/BasicInformation.vue